<template>
  <div class="login-wrapper">

    <div class="login">

      <img src="/static/img/suez-white.png" class="logo"/>

      <h2>Mot de passe oublié</h2>

      <!-- login form -->
      <form class="ui form loginForm" v-on:submit.prevent="submit">

        <div class="input-group">
          <input class="form-control" name="username" placeholder="Nouveau mot de passe" type="password" v-model="newPassword">
        </div>

        <div class="input-group">
          <input class="form-control" name="password" placeholder="Confirmez le mot de passe" type="password"
                 v-model="confirmNewPassword">
        </div>

        <div v-if="login.message !== null"
             v-bind:class="'callout callout-'+login.message.type">
          <p>{{login.message.text}}</p>
        </div>
      </form>
      <button v-on:click="submit" v-bind:class="'btn btn-primary btn-lg'">Valider
      </button>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    computed: {
      ...mapState([
        'login',
      ]),
    },
    data () {
      return {
        newPassword: '',
        confirmNewPassword: '',
      }
    },
    methods: {
      submit () {
        console.log("reset it => " , this.$route.params.maitriseId)
        this.$store.dispatch('resetPassword', {
          password: this.newPassword,
          confirmPassword: this.confirmNewPassword,
          maitriseId: this.$route.params.maitriseId
        })
      },
    },
  }
</script>

<style lang="scss">
  @import '../scss/variables';
</style>



// WEBPACK FOOTER //
// ResetPassword.vue?43b15726